module.exports = __webpack_public_path__ + "img/22.6a82e207.jpg";